<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">{{ $t('menu.policyExpressMailSubscription') }}</span>
      </div>
    </div>
    
    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        align="center"
        :columns="columns"
        :data="tableData"
        :operation-column-width="100"
        @change-filter="changeFilter"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="handleEdit(row)">{{ $t('handleEdit') }}</span>
          </div>
        </template>
      </air-table>
      <bsp-pagination :pager-config.sync="pagerConfig" @page-change="pageChange"></bsp-pagination>
    </div>
    
    <el-dialog class="modal-v2" :title="modal.title" :visible.sync="modal.show" :close-on-click-modal="false" width="600px" append-to-body v-dialog-drag>
      <el-form ref="form" class="form-v2" :model="form" :rules="formRules" :label-width="lang == 'en' ? '170px' : '100px'" style="margin: 40px 0; padding: 0 30px;" size="small" label-suffix="：">
        <el-form-item class="fixed-height" :label="$t('customerName')">
          <div class="text-left">{{ form.cusName }}</div>
        </el-form-item>
        <el-form-item class="fixed-height" :label="$t('accountName')">
          <div class="text-left">{{ form.hrLoginName }}</div>
        </el-form-item>
        <el-form-item class="fixed-height" :label="$t('userName')">
          <div class="text-left">{{ form.hrName }}</div>
        </el-form-item>
        <el-form-item class="fixed-height" :label="$t('phoneNumber')">
          <div class="text-left">{{ form.hrPhone }}</div>
        </el-form-item>
        <el-form-item class="fixed-height" :label="$t('email')" prop="hrEmail">
          <el-input v-model="form.hrEmail" clearable :placeholder="$t('inputPlaceholder')"></el-input>
        </el-form-item>
        <el-form-item class="fixed-height" :label="$t('subscriptionStatus')" prop="isValid">
          <el-select v-model="form.isValid" filterable clearable>
            <el-option v-for="item in isValidList" :key="item.codeItemId" :value="item.codeItemId" :label="item[lang == 'en' ? 'codeItemEnName' : 'codeItemName']" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="modal.show = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">{{ $t('save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as api from '@/api/policy/policyLibraryManagement';
  import { mapGetters } from 'vuex';
  
  export default {
    name: 'PolicyExpressMailSubscription',
    data() {
      return {
        loading: true,
        dictMap: {},
        isValidList: [
          { codeItemId: '0', codeItemName: '取消订阅', codeItemEnName: 'Unsubscribe' },
          { codeItemId: '1', codeItemName: '开启订阅', codeItemEnName: 'Enable subscription' },
          { codeItemId: '2', codeItemName: '关闭订阅', codeItemEnName: 'Close subscription' }
        ],
        pagerConfig: {
          page: 1,
          limit: 20,
          total: 0
        },
        queryParams: {},
        total: 0,
        columns: [],
        tableData: [],
        form: {},
        formRules: {
          hrEmail: [{ required: true, message: this.$t('inputPlaceholder'), trigger: 'blur' }],
          isValid: [{ required: true, message: this.$t('pleaseSelect'), trigger: 'change' }]
        },
        modal: {
          show: false,
          title: this.$t('handleEdit')
        },
        submitLoading: false
      }
    },
    computed: {
      ...mapGetters(['lang'])
    },
    created() {
      this.getColumns();
      this.getData()
    },
    methods: {
      resetForm(formName) {
        if (this.$refs[formName] !== undefined) {
          this.$refs[formName].resetFields();
        }
      },
      pageChange({ type, currentPage, pageSize }) {
        if (type == 'size') {
          this.pagerConfig.page = 1;
        }
        this.getData();
      },
      getColumns() {
        this.columns = [
          {title: this.$t('customerName'), field: 'cusName', minWidth: 200, filterType: 'input'},
          {title: this.$t('accountName'), field: 'hrLoginName', minWidth: 120, filterType: 'input'},
          {title: this.$t('userName'), field: 'hrName', minWidth: 120, filterType: 'input'},
          {title: this.$t('phoneNumber'), field: 'hrPhone', minWidth: 120, filterType: 'input'},
          {title: this.$t('email'), field: 'hrEmail', minWidth: 120, filterType: 'input'},
          {title: this.$t('subscriptionStatus'), field: 'isValidText', minWidth: 120, filterType: 'select', filterOptions: this.isValidList}
        ]
      },
      getData() {
        this.loading = true
        const { page, limit } = this.pagerConfig;
        let params = {
          pageNum: page,
          pageSize: limit,
          ...this.queryParams
        }
        api.emailList(params)
          .then(res => {
            if (!this.dictMap.isValid) {
              this.dictMap.isValid = this.$arrayToObj(this.isValidList, 'codeItemId');
            }
            this.tableData = this.$handleTableDict(res.data.data.list, this.dictMap);
            this.pagerConfig.total = res.data.data.total;
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
          })
      },
      changeFilter(e) {
        this.queryParams = {...this.queryParams, ...e.filterData};
        this.pagerConfig.page = 1;
        this.getData();
      },
      reset() {
        this.form = {};
        this.resetForm('form');
      },
      handleEdit(row) {
        this.form = {
          ...row
        }
        this.modal.show = true;
      },
      handleSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            api.emailUpdate(this.form).then(res => {
              if (res.data.code === 0) {
                this.modal.show = false;
                this.getData();
              }
            }).finally(() => this.submitLoading = false)
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/air/assets/css/main.scss";
  
  .wage-month-bg {
    width: 649px;
    height: 60px;
    background: #F8F9FA;
    border-radius: 4px;
  }
</style>
